<template>
  <div class="row">
    <div class="col-12">
      <card :title="trans.admins.show.title" :subTitle="trans.admins.show.description">
        <back-button v-if="hasPermissions('admins')" :routeName="'admins'"></back-button>
        <div class="row mt-5">
          <div class="col-md-10 offset-md-1">
            <table class="table table-striped table-bordered">
             
              <tbody>

                <tr>
                  <th>
                    {{trans.actions.actions}}
                  </th>
                  <td>
                      <edit-button v-if="hasPermissions('admins_edit')" :routing="{name: 'admins.edit', params: {id: user.id}}"></edit-button>
                      <delete-button v-if="hasPermissions('admins_delete') && user.id != 1" :deleteUrl="'/admins/' + user.id" :data="user" @deleteData="deleteData"></delete-button>
                  </td>
                </tr>

                <tr>
                  <th>
                    {{trans.admins.fields.name}}
                  </th>
                  <td>
                    {{ user.name }}
                  </td>
                </tr>

                <tr>
                  <th>
                    {{trans.admins.fields.email}}
                  </th>
                  <td>
                    {{ user.email }}
                  </td>
                </tr>

                <tr>
                  <th>
                    {{trans.admins.fields.username}}
                  </th>
                  <td>
                    {{ user.user_name }}
                  </td>
                </tr>

                <tr>
                  <th>
                    {{trans.admins.fields.role}}
                  </th>
                  <td>
                    {{ user.role }}
                  </td>
                </tr>


                <tr>
                  <th>
                    {{trans.global.added_at}}
                  </th>
                  <td>
                    {{ user.created_at }}
                  </td>
                </tr>

                 <tr>
                  <th>
                    {{trans.admins.fields.status}}
                  </th>
                  <td v-if="user.status">
                    <i class="fa fa-check-circle text-success fa-2x"></i>
                  </td>
                  <td v-else>
                    <i class="fa fa-times-circle text-danger fa-2x"></i>
                  </td>
                </tr>

              </tbody>
            </table>

          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import router from '@/router'

export default {
  data() {
    return {
      user: {},
      isRequested: false,
    };
  },
  created() {
    this.findOne();
  },
  methods: {
    findOne() {
      this.$baseApi.get('/admins/' + this.$route.params.id).then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.user = response.data.data;
          this.user.id = this.$route.params.id;
        } else if (response.data.code === 404) {
          router.push('/admins');
        } else {
          alert(response.data.error);
          router.push('/admins');
        }
      });
    },
    deleteData(data){
      router.push('/users');
    }
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    }
  }
}

</script>
<style>
</style>
